export const SITE_EMPTY_NAME = "NOT NAMED YET" as const;
